import styled from "styled-components";

export const TopWrapper = styled.div`
  margin-bottom: 20px;
`
export const TotalStudents = styled.span`
  font-weight: 700;
`

export const List = styled.ul`
  display: flex;
  width: 100%;

  flex-wrap: ${(props) => (props.isAllAdmin ? "" : "wrap")};
  gap: ${(props) => (props.isAllAdmin ? "" : "25px")};
`;

export const Item = styled.li`
  padding: 15px 5px;
  background: #f1f1f1;
  box-shadow: 0px 4px 4px 0px #00000040;
  cursor: pointer;
  ${(props) =>
    !props.isAllAdmin
      ? `
      flex-basis: calc(100% / 3 - 25px);
      
      @media (min-width: 768px) {
         flex-basis: calc(100% / 4 - 25px);
      }
      `
      : `
      &:not(:last-child) {
         margin-bottom: 20px;
      }
      `}

  &:hover {
    opacity: 0.75;
  }
`;

export const AddStudentItem = styled(Item)`
  background: #ffe1a2;
`;

export const ItemTitle = styled.p`
  font-family: Raleway;
  font-size: 18px;
  font-weight: 700;
  line-height: 24.2px;

  text-align: left;
`;

export const SearchInput = styled.input`
  padding: 10px 15px;
  margin-top: 10px;
  width: 100%;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  margin-bottom: 25px;
`;